import { render } from "./PrivacyAndRefundPolicy.vue?vue&type=template&id=2802552c&scoped=true"
import script from "./PrivacyAndRefundPolicy.vue?vue&type=script&lang=js"
export * from "./PrivacyAndRefundPolicy.vue?vue&type=script&lang=js"

import "./PrivacyAndRefundPolicy.vue?vue&type=style&index=0&id=2802552c&scoped=true&lang=scss"
import "./PrivacyAndRefundPolicy.vue?vue&type=style&index=1&id=2802552c&lang=scss"

import exportComponent from "/home/runner/work/dating-app/dating-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2802552c"]])

export default __exports__